import React from 'react';
import {
  ImageBackground,
  ImageSourcePropType,
  StyleSheet,
} from 'react-native';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Stack,
  BodyText,
  Touchable,
} from '../../../ui';

export type MicroSearchTileProps = {
  serviceName: string;
  serviceImage: ImageSourcePropType;
  onClick: (serviceName: string) => void;
};

const MicroSearchTile: React.FCWithChildren<MicroSearchTileProps> = ({
  onClick,
  serviceName,
  serviceImage,
}) => (
  <Touchable
    onClick={() => onClick(serviceName)}
    testID={`micro-search-tile-${serviceName.replace(' ', '-').toLowerCase()}`}
  >
    <Stack
      maxWidth={77}
      showBoxShadow
      color={colors.whiteWash}
      alignItems="center"
      justifyContent="flex-start"
      testID={`micro-search-tile-${serviceName}`}
    >
      <Box
        minWidth={77}
        minHeight={63}
        maxHeight={63}
      >
        <ImageBackground
          style={StyleSheet.absoluteFill}
          source={serviceImage}
        />
      </Box>
      <Box
        flexGrow={1}
        minWidth="100%"
        justifyContent="center"
        paddingX={12}
        paddingY={4}
      >
        <BodyText
          whiteSpace="wrap"
          textAlign="center"
          appearance="small"
        >
          {serviceName}
        </BodyText>
      </Box>
    </Stack>
  </Touchable>
);

export default MicroSearchTile;
